module.exports = __webpack_public_path__ + "static/opc3-742411ea1ecb4b571adf8b28b92c59d7.png";